import { z } from 'zod';

export const zodDeleteUnitMappingSchema = z.uuid();

export const zodDeleteUnitMappingEndpointSchema = z.tuple([
  z.literal('units'),
  z.literal('unit_mapping'),
  z.uuid(),
]);
